import { CollectionItem, CollectionMetafields } from "~/types";
import { collectionList, showContactLink } from "../../../setup/settings/__collection";
import CollectionCard from "./CollectionCard.client";
import CollectionCardItem from "./CollectionCardItem.client";
import CustomCollectionList from "../../../setup/components/CustomCollectionList.client";



type CollectionListProps = {
    collection: CollectionMetafields,
}

export default function CollectionList({ collection }: CollectionListProps) {

    return (
        <>
            {collectionList.default ?
                <DefaultCollectionList collection={collection}></DefaultCollectionList>
                :
                <CustomCollectionList collection={collection}></CustomCollectionList>
            }
        </>
    );
}


function DefaultCollectionList({ collection }: CollectionListProps) {
    const productRanges: CollectionItem[] = collection.productRanges?.value != null
        && collection.productRanges?.value != "" ? JSON.parse(collection.productRanges?.value) : [];
    const sortCollection = (a: CollectionItem, b: CollectionItem) => {
        if (a.Title != null && b.Title != null) {
            if (a.Title < b.Title) return -1;
            if (a.Title > b.Title) return 1;
        }
        return 0
    }
    const productRangesSort = productRanges.sort(sortCollection);
    const contactField = JSON.parse(collection.customField?.value ?? 'false').contactfield ?? 'false';
    const contactUrl = JSON.parse(collection.customField?.value ?? 'false').contacturl ?? 'false';
    const type = collection.collectionType?.value;
    const image = collection.image?.url ?? "";

    return (<>
        {collectionList && collectionList.contactUrl && showContactLink ?
            <div className="container-line mt-18 mb-12">
                <h1 className={`containerCollection__title text-center text-2xl `}>
                    {collection.title}
                </h1>
                {collection.descriptionHtml &&
                    <div className="collection-descriptionHtml" dangerouslySetInnerHTML={{ __html: collection.descriptionHtml }}></div>
                }
                {contactField != 'false' && contactUrl != 'false' &&
                    <a className="collection-contact-url " href={contactUrl}>
                        <u className="collection-contact-field">{contactField}</u>
                    </a>
                }
            </div> :
            <div className="container-line mt-28 mb-12">
                <h1 className="containerCollection__title text-center text-2xl">
                    {collection.title}
                    {collection.descriptionHtml &&
                        <div className="collection-descriptionHtml" dangerouslySetInnerHTML={{ __html: collection.descriptionHtml }}></div>
                    }
                </h1>
            </div>
        }
        <div className="text-lg" />
        <ul className="">
            <div className="containerCollection__grid grid xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-4 px-4 mb-28">
                {productRangesSort?.length > 0 && productRangesSort?.filter(pr => pr.HasProduct).map((c: CollectionItem) => c && <CollectionCardItem collection={c} />)}
            </div>
        </ul>
    </>)
}
